import {
  getTimeTableColumn,
  getCopyWithContentTableColumn,
  // getStatusTableColumn,
} from '@/utils/common/tableColumn'
import { cityMap } from '@/utils/utils'

export default {
  async created () {
    this.columns = [
      getCopyWithContentTableColumn({
        field: 'name',
        title: '项目名称',
      }),
      getCopyWithContentTableColumn({
        field: 'enterprise_name',
        title: '客户企业名称',
        minWidth: 150,
      }),
      {
        field: 'amount',
        title: '项目规模（万元）',
        minWidth: 120,
      },
      {
        field: 'address',
        title: '项目所在地',
        minWidth: 110,
        formatter: ({ cellValue }) => {
          return cityMap(this.cities, cellValue)
        },
      },
      getCopyWithContentTableColumn({
        field: 'contact',
        title: '客户联系人',
        minWidth: 110,
      }),
      getCopyWithContentTableColumn({
        field: 'department',
        title: '客户联系人所属部门',
        minWidth: 130,
      }),
      getCopyWithContentTableColumn({
        field: 'position',
        title: '客户联系人职位',
        minWidth: 110,
      }),
      getTimeTableColumn({ title: '报备提交时间', sortable: true }),
      {
        field: 'created_at',
        title: '项目预估截止时间',
        sortable: true,
        minWidth: 160,
        formatter: ({ cellValue }) => {
          return cellValue ? this.$moment(cellValue).add(3, 'M').format() : '-'
        },
      },
      // getStatusTableColumn({ title: '报备进度', statusModule: 'reportProject', minWidth: 100 }),
      {
        field: 'status',
        title: '报备进度',
        sortable: true,
        minWidth: 100,
        slots: {
          default: ({ row }) => {
            const status = {
              init: '未开始',
              accept: '报备成功',
              refused: '报备失败',
              expired: '已过期',
            }
            const statusClass = {
              init: 'status-info',
              accept: 'status-success',
              refused: 'status-danger',
              expired: 'status-danger',
            }
            if (row.status === 'refused') {
              return [
                <div class='text-truncate' class={ statusClass[row.status] }>{ status[row.status] }
                  <a-tooltip>
                    <template slot="title">
                      { row.memo }
                    </template>
                    <a-icon type="question-circle" class="ml-1" />
                  </a-tooltip>
                </div>,
              ]
            }
            return [
              <div class='text-truncate' class={ statusClass[row.status] }>{ status[row.status] }</div>,
            ]
          },
        },
      },
      // getCopyWithContentTableColumn({
      //   field: 'memo',
      //   title: '报备失败原因',
      //   minWidth: 110,
      // }),
    ]
  },
}
